<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $t('itemcostprice') }}</div>
      <router-link class="btn-blue" to="itemcostprice">{{ $t('itemcostprice') }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="selectedCinema.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(cinema,cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  @click="onSelectCinema(cinema)"
                  name="selectcinema"
                  id="selectcinema"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <Tooltip :title="$t('user_Cinema')" />
          </div>
          <p v-if="submitted && selectedCinema.length == 0" class="error_message">{{ errmsg }}</p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container pr-28px">
            <label :class="selectedFnbItem.length > 0 ? 'shift-up' : '' ">{{ $t('fnbitems') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown :text="selectedFnbItem" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(fnbItem,fnbItemIndex) in fnb_items"
                  :key="fnbItemIndex"
                  href="#"
                  @click="onSelectFnbItem(fnbItem)"
                >{{ fnbItem.recipe_name }}</b-dropdown-item>
              </b-dropdown>
              <Tooltip :title="$t('itemcostprice_fnb')" />
            </div>
            <p v-if="submitted && selectedFnbItem.length == 0" class="error_message">{{ errmsg1 }}</p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="itemcost_price.costprice"
                name="costprice"
                id="costprice"
                v-validate="'required|decimal'"
              />
              <label>{{ $t('itemcostprice') }}</label>
            </div>
            <Tooltip :title="$t('itemcostprice_costPrice')" />
          </div>
          <p
            v-if="submitted && errors.has('costprice')"
            class="error_message"
          >{{ errors.first('costprice') }}</p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="itemcost_price.fp_is_active"
                type="checkbox"
                class="ios-checkbox"
                checked
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">{{ $t('save') }}</button>
          <button
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button v-on:click="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button class="btn-outline-grey" variant="default" to="itemcostprice">{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      submitted: false,
      errmsg: "",
      errmsg1: "",
      Cinemas: [],
      fnb_items: [],
      selectedCinema: "",
      selectedFnbItem: "",
      itemcost_price: {
        cinema_id: "",
        v_id: "",
        item_id: "",
        costprice: "",
        fp_is_active: true
      }
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    this.getFnbItems();
  },
  methods: {
    getCinemaList: function(cine_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            // this.Cinemas.map(x => {
            //   if (String(cine_id) === String(x.cine_id)) {
            //     this.selectedCinema = x.cine_name;
            //     this.itemcost_price.cinema_id = x.cine_id;
            //   }
            // });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getFnbItems: function() {
      let payload = {
        limit: null,
        currentPage: null
      };
      PosFnbService.GetAllFnBItems(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.fnb_items = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    onSelectCinema: function(cinema) {
      this.selectedCinema = cinema.cine_name;
      this.itemcost_price.cinema_id = cinema.cine_id;
      this.getItemCostPrice(
        this.itemcost_price.cinema_id,
        this.itemcost_price.item_id
      );
    },
    onSelectFnbItem: function(fnbItem) {
      this.selectedFnbItem = fnbItem.recipe_name;
      this.itemcost_price.item_id = parseInt(fnbItem.item_id);
      this.getItemCostPrice(
        this.itemcost_price.cinema_id,
        this.itemcost_price.item_id
      );
    },

    getItemCostPrice: function(cinema_id, item_id) {
      if (cinema_id && item_id) {
        PosFnbService.GetItemsCostPrice({ cinema_id, item_id })
          .then(response => {
            const { data } = response;
            if (data && data.status) {
              // console.log("data :", data);
              this.itemcost_price.costprice = data.total || data.ItemCostPrice
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },

    onResetForm: function() {
      this.selectedCinema = "";
      this.selectedFnbItem = "";
      this.itemcost_price.costprice = "";
      this.itemcost_price.item_id = "";
      this.itemcost_price.v_id = "";
      this.secureStore.get("USINFO").cinema_id
        ? this.getCinemaList(this.secureStore.get("USINFO").cinema_id)
        : "";
    },

    onFinalSubmit: function(flag) {
      this.submitted = true;
      if (this.selectedCinema.length == 0) {
        this.errmsg = "Please Select Cinema.";
        return;
      } else if (this.selectedFnbItem == 0) {
        this.errmsg1 = "Please Select F&B Item.";
        return;
      } else {
        this.$validator.validate().then(valid => {
          // console.log("valid :", valid);
          if (valid) {
            let payload = {
              ...this.itemcost_price
            };
            console.log("payload :", payload);
            PosFnbService.AddItemCostPrice(payload)
              .then(response => {
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  if (flag) {
                    this.$router.push({
                      path: "/fnb/itemcostprice"
                    });
                    this.submitted = false;
                    this.$toasted.show(data.message);
                  }
                  this.$toasted.show(data.message);
                  this.submitted = false;
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/ItemCostPriceComponents/addItemCostPrice.vue